// extracted by mini-css-extract-plugin
export default {"notificationCard":"NotificationCard_notificationCard__buAD4","title":"NotificationCard_title__Xt-FQ","body":"NotificationCard_body__YxUja"};